export default "__VITE_ASSET__4c304375__"